/* Designs by Loretta Dawn — theme behaviour */
(() => {
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = window.Shopify && Shopify.designMode;
  if (inEditor || reduce) root.classList.add('no-anim');

  /* Scroll reveals */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { threshold: .14, rootMargin: '0px 0px -6% 0px' });
  // Clip-path masks are invisible to IntersectionObserver, so watch their parent instead
  const mio = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.querySelectorAll(':scope > .mask').forEach(m => m.classList.add('in')); mio.unobserve(e.target); }
  }), { threshold: .1 });

  /* Count-up stats */
  const cio = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target, end = +el.dataset.count, suffix = el.dataset.suffix || '';
    cio.unobserve(el);
    if (!end || end > 999 || reduce) return;
    const t0 = performance.now();
    (function tick(t) {
      const k = Math.min(1, (t - t0) / 1600), v = Math.round(end * (1 - Math.pow(1 - k, 3)));
      el.textContent = v + (k === 1 ? suffix : '');
      if (k < 1) requestAnimationFrame(tick);
    })(t0);
  }), { threshold: .6 });

  /* Review rotator */
  function initReviews(scope) {
    scope.querySelectorAll('[data-reviews]').forEach(box => {
      const qs = [...box.querySelectorAll('.quote')], bars = [...box.querySelectorAll('.progress button')], thumbs = [...box.querySelectorAll('.qthumb img')];
      if (!qs.length) return;
      let i = 0, timer;
      const show = n => {
        i = n;
        qs.forEach((q, k) => q.classList.toggle('on', k === n));
        thumbs.forEach((q, k) => q.classList.toggle('on', k === n));
        bars.forEach((b, k) => { b.classList.remove('on'); b.classList.toggle('done', k < n); void b.offsetWidth; if (k === n) b.classList.add('on'); });
        clearTimeout(timer);
        if (qs.length > 1 && !inEditor) timer = setTimeout(() => show((i + 1) % qs.length), 6500);
      };
      bars.forEach((b, k) => b.addEventListener('click', () => show(k)));
      show(0);
    });
  }

  /* Collection hover preview */
  let px = 0, py = 0, tx = 0, ty = 0, peek = null;
  function initPeek(scope) {
    scope.querySelectorAll('.index a[data-img]').forEach(a => {
      a.addEventListener('mouseenter', () => {
        peek = a.closest('section').querySelector('.peek');
        if (!peek || !a.dataset.img) return;
        peek.querySelector('img').src = a.dataset.img; peek.classList.add('on');
      });
      a.addEventListener('mouseleave', () => peek && peek.classList.remove('on'));
    });
  }
  addEventListener('mousemove', e => { tx = innerWidth * .62 + (e.clientX - innerWidth / 2) * .08; ty = e.clientY; });
  (function loop() { px += (tx - px) * .12; py += (ty - py) * .12; if (peek) { peek.style.left = px + 'px'; peek.style.top = py + 'px'; } requestAnimationFrame(loop); })();

  /* Product page: gallery + variant picker + quantity */
  function initProduct(scope) {
    scope.querySelectorAll('[data-gallery]').forEach(g => {
      const imgs = [...g.querySelectorAll('.product-stage img')], btns = [...g.querySelectorAll('.thumbs button')];
      const show = id => { imgs.forEach(i => i.classList.toggle('on', i.dataset.media === id)); btns.forEach(b => b.classList.toggle('on', b.dataset.media === id)); };
      btns.forEach(b => b.addEventListener('click', () => show(b.dataset.media)));
      g.showMedia = show;
    });
    scope.querySelectorAll('[data-variant-select]').forEach(sel => {
      sel.addEventListener('change', () => {
        const o = sel.selectedOptions[0], form = sel.closest('form'), wrap = sel.closest('.product');
        const price = wrap.querySelector('[data-price]'), btn = form.querySelector('[data-add]');
        if (price) price.innerHTML = o.dataset.price;
        if (btn) { btn.disabled = o.dataset.available !== 'true'; btn.querySelector('[data-add-label]').textContent = btn.disabled ? btn.dataset.soldout : btn.dataset.add; }
        const g = wrap.querySelector('[data-gallery]');
        if (g && o.dataset.media && g.showMedia) g.showMedia(o.dataset.media);
        const u = new URL(location.href); u.searchParams.set('variant', sel.value); history.replaceState({}, '', u);
      });
    });
    scope.querySelectorAll('.qty').forEach(q => {
      const input = q.querySelector('input');
      q.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
        const min = +(input.min || 0);
        input.value = Math.max(min, (+input.value || 0) + (+b.dataset.step));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
    });
    scope.querySelectorAll('[data-auto-submit]').forEach(f => f.addEventListener('change', e => { if (e.target.matches('.qty input')) f.submit(); }));
    scope.querySelectorAll('[data-sort]').forEach(s => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u; }));
  }

  function init(scope) {
    scope.querySelectorAll('.r, .head h2 .line-in, .closing h2 .line-in, .page-head .line-in').forEach(el => io.observe(el));
    scope.querySelectorAll('.mask').forEach(m => mio.observe(m.parentElement));
    scope.querySelectorAll('[data-count]').forEach(el => cio.observe(el));
    requestAnimationFrame(() => scope.querySelectorAll('.hero .line-in, .hero .r').forEach(el => el.classList.add('in')));
    initReviews(scope); initPeek(scope); initProduct(scope);
  }
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  // In the theme editor, open a collection dropdown when its block is selected
  document.addEventListener('shopify:block:select', e => { if (e.target.matches('details')) e.target.open = true; });

  /* Header: tint on scroll, tuck away on scroll down; gentle hero parallax */
  const hdr = document.getElementById('hdr');
  let last = 0;
  const onScroll = () => {
    const y = scrollY;
    if (hdr) {
      hdr.classList.toggle('scrolled', y > 40);
      hdr.classList.toggle('hide', y > last && y > 400 && !document.body.classList.contains('menu-open'));
    }
    last = y;
    if (!reduce && !inEditor) document.querySelectorAll('[data-par]').forEach(el => { const img = el.querySelector('img, svg'); if (img) img.style.translate = `0 ${y * parseFloat(el.dataset.par)}px`; });
  };
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* Mobile menu */
  const toggle = document.querySelector('.menu-toggle'), menu = document.getElementById('mobile-menu');
  if (toggle && menu) {
    const set = open => {
      menu.classList.toggle('open', open); document.body.classList.toggle('menu-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      toggle.setAttribute('aria-expanded', open); toggle.textContent = open ? toggle.dataset.close : toggle.dataset.open;
    };
    toggle.addEventListener('click', () => set(!menu.classList.contains('open')));
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => set(false)));
    addEventListener('keydown', e => { if (e.key === 'Escape') set(false); });
  }
})();
